import React from 'react';

import { Logo } from '@motorway/mw-highway-code';

import { ReactComponent as EmpathyLogo } from '../../../../../client/assets_seller/partners/empathy.svg';

import styles from './HomeVRM.scss';

export const HomeVRMBereavement = () => (
  <div className={styles.bereavementLogoWrapper}>
    <Logo size="large" />
    <span className={styles.bereavementDivider} />
    <EmpathyLogo />
  </div>
);
